<template>
  <div class="container switch-page">
    <!-- 头部导航 -->
    <header-bar name="订单详情" />

    <!-- loading加载区域 -->
    <div class="loading-list" v-if="!isComplete">
      <van-loading type="spinner" />
    </div>

    <!-- 订单状态栏 -->
    <div class="status-bar" v-if="isComplete && orderDetail.id">
      <div class="status-left">
        <span class="status-icon">¥</span>
        <span class="status-text">{{ getOrderStatus(orderDetail.state) }}</span>
      </div>
      <div class="status-right" v-if="orderDetail.type">
        {{ getOrderType(orderDetail.type) }}
      </div>
    </div>

    <!-- 陪诊订单详细信息 -->
    <div v-if="isComplete && orderDetail.id && orderDetail.type === 'ACCOMPANY_DIAGNOSE'">
      <!-- 服务信息 -->
      <div class="wrap-box">
        <div class="hd">{{ getAccompanyType(orderDetail.accompanyType) }}</div>
        <div class="base-wrap">
          <div class="row" v-if="orderDetail.productName">
            <div class="lab">服务规格</div>
            <div class="inf">{{ orderDetail.productName }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyStartDateTime && orderDetail.accompanyEndDateTime">
            <div class="lab">服务时长</div>
            <div class="inf">{{ calculateDuration(orderDetail.accompanyStartDateTime, orderDetail.accompanyEndDateTime) }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyStartDateTime">
            <div class="lab">服务时间</div>
            <div class="inf">{{ orderDetail.accompanyStartDateTime }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyHospitalName">
            <div class="lab">就诊医院</div>
            <div class="inf">{{ orderDetail.accompanyHospitalName }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyType !== 'TEMPERATURE_TAKING' && orderDetail.accompanySectionName">
            <div class="lab">就诊科室</div>
            <div class="inf">{{ orderDetail.accompanySectionName }}</div>
          </div>
          <div class="row" v-if="orderDetail.attendantPatientName || orderDetail.attendantPatientPhone">
            <div class="lab">就诊人姓名</div>
            <div class="inf">
              <span v-if="orderDetail.attendantPatientName">{{ orderDetail.attendantPatientName }}</span>
              <span v-if="orderDetail.attendantPatientAge"> {{ orderDetail.attendantPatientAge }}岁</span>
              <span v-if="orderDetail.attendantPatientGender !== null && orderDetail.attendantPatientGender !== undefined">
                {{ orderDetail.attendantPatientGender == 0 ? ' 女' : ' 男' }}
              </span>
            </div>
          </div>
          <div class="row" v-if="orderDetail.attendantPatientPhone">
            <div class="lab">就诊人电话</div>
            <div class="inf phone-link" @click="makeCall(orderDetail.attendantPatientPhone)">
              {{ orderDetail.attendantPatientPhone }}
              <span class="phone-icon">📞</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 陪诊师要求 -->
      <div class="wrap-box" v-if="orderDetail.accompanyGender !== null && orderDetail.accompanyGender !== undefined || 
                                  orderDetail.accompanyDrivingLicense !== null && orderDetail.accompanyDrivingLicense !== undefined ||
                                  (orderDetail.accompanyStartAge !== null && orderDetail.accompanyEndAge !== null)">
        <div class="hd">陪诊师要求</div>
        <div class="base-wrap">
          <div class="row" v-if="orderDetail.accompanyGender !== null && orderDetail.accompanyGender !== undefined">
            <div class="lab">性别</div>
            <div class="inf">{{ orderDetail.accompanyGender == 0 ? '女' : '男' }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyDrivingLicense !== null && orderDetail.accompanyDrivingLicense !== undefined">
            <div class="lab">是否会驾驶</div>
            <div class="inf">
              {{ orderDetail.accompanyDrivingLicense === null ? '不限' : orderDetail.accompanyDrivingLicense === true ? '会' : '不会' }}
            </div>
          </div>
          <div class="row" v-if="orderDetail.accompanyStartAge !== null && orderDetail.accompanyEndAge !== null">
            <div class="lab">年龄要求</div>
            <div class="inf">
              {{ (orderDetail.accompanyStartAge == 0 && orderDetail.accompanyEndAge == 300) ? '不限' : orderDetail.accompanyStartAge + "岁-" + orderDetail.accompanyEndAge + "岁" }}
            </div>
          </div>
        </div>
      </div>

      <!-- 其他需求 -->
      <div class="wrap-box" v-if="orderDetail.accompanyContent || orderDetail.accompanyReceptionAddress || orderDetail.accompanyRegistrationImg">
        <div class="hd">其他需求</div>
        <div class="base-wrap">
          <div class="row" v-if="orderDetail.accompanyReceptionAddress">
            <div class="lab">接送地址</div>
            <div class="inf">{{ orderDetail.accompanyReceptionAddress }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyContent">
            <div class="lab">备注</div>
            <div class="inf">{{ orderDetail.accompanyContent }}</div>
          </div>
          <div class="row" v-if="orderDetail.accompanyRegistrationImg">
            <div class="lab">挂号照片</div>
            <div class="inf">
              <div class="image-list">
                <div class="image-item" v-for="(img, index) in getImageList(orderDetail.accompanyRegistrationImg)" :key="index" @click="previewImage(img)">
                  <img :src="img" alt="挂号照片" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 陪诊师信息 -->
      <div class="wrap-box" v-if="orderDetail.receivingUserName">
        <div class="hd">陪诊师</div>
        <div class="base-wrap">
          <div class="row">
            <div class="lab">陪诊师姓名</div>
            <div class="inf">{{ orderDetail.receivingUserName }}</div>
          </div>
          <div class="row" v-if="orderDetail.receivingUserGender !== null && orderDetail.receivingUserGender !== undefined">
            <div class="lab">陪诊师性别</div>
            <div class="inf">{{ orderDetail.receivingUserGender == 0 ? '女' : '男' }}</div>
          </div>
          <div class="row" v-if="orderDetail.receivingPhone">
            <div class="lab">联系电话</div>
            <div class="inf phone-link" @click="makeCall(orderDetail.receivingPhone)">
              {{ orderDetail.receivingPhone }}
              <span class="phone-icon">📞</span>
            </div>
          </div>
          <div class="row" v-if="orderDetail.receivingUserAge">
            <div class="lab">年龄</div>
            <div class="inf">{{ orderDetail.receivingUserAge }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 订单时间信息 -->
    <div class="wrap-box" v-if="isComplete && orderDetail.id">
      <div class="hd">订单时间</div>
      <div class="base-wrap">
        <div class="row">
          <div class="lab">订单号码</div>
          <div class="inf">{{ orderDetail.sn }}</div>
        </div>
        <div class="row">
          <div class="lab">下单时间</div>
          <div class="inf">{{ orderDetail.createTime }}</div>
        </div>
        <div class="row" v-if="orderDetail.takeOrderTime">
          <div class="lab">接单时间</div>
          <div class="inf">{{ orderDetail.takeOrderTime }}</div>
        </div>
        <div class="row" v-if="orderDetail.payTime">
          <div class="lab">支付时间</div>
          <div class="inf">{{ orderDetail.payTime }}</div>
        </div>
        <div class="row" v-if="orderDetail.finishTime">
          <div class="lab">完成时间</div>
          <div class="inf">{{ orderDetail.finishTime }}</div>
        </div>
        <div class="row">
          <div class="lab">价格</div>
          <div class="num">￥{{ orderDetail.practicalPrice }}</div>
        </div>
      </div>
    </div>

    <!-- 下单人信息 -->
    <div class="wrap-box" v-if="isComplete && orderDetail.id && orderDetail.sendUserName">
      <div class="hd">下单人信息</div>
      <div class="base-wrap">
        <div class="row">
          <div class="lab">下单人</div>
          <div class="inf">
            {{ orderDetail.sendUserName }} - {{ orderDetail.sendPhone }}
          </div>
        </div>
        <div class="row" v-if="orderDetail.adCodeName">
          <div class="lab">所属地区</div>
          <div class="inf">{{ orderDetail.adCodeName }}</div>
        </div>
      </div>
    </div>

    <div class="wrap-box" v-if="isComplete && orderDetail.id && orderDetail.productName">
      <div class="hd">商品信息</div>
      <div class="base-wrap">
        <div class="row">
          <div class="lab">商品名称</div>
          <div class="inf">{{ orderDetail.productName }}</div>
        </div>
        <div class="row" v-if="orderDetail.type">
          <div class="lab">订单类型</div>
          <div class="inf">{{ getOrderType(orderDetail.type) }}</div>
        </div>
      </div>
    </div>

    <div class="wrap-box" v-if="isComplete && orderDetail.id && orderDetail.remark">
      <div class="hd">备注信息</div>
      <div class="introduction">{{ orderDetail.remark }}</div>
    </div>
  </div>
</template>

<script>
import HeaderBar from "components/HeaderBar/HeaderBar";
import { orderDetail } from "@/api/home";

export default {
  name: "OrderDetail",
  components: {
    HeaderBar,
  },
  data() {
    return {
      orderDetail: {},
      isComplete: false,
      orderTypeMap: {
        ACCOMPANY_DIAGNOSE: "陪诊",
        BUY_MEDICINE: "买药",
        INTERROGATION_DIAGNOSE: "问诊",
        SEND_RESULTS: "送取结果",
        OPEN_VIP: "开通会员",
        RENEW: "加时包",
        OPEN_VIP_YEAR: "开通年会员",
        INTEREST_PACKAGE: "权益套餐",
        GOODS: "商品",
      },
    };
  },
  methods: {
    // 获取订单状态文本
    getOrderStatus: function (state) {
      const statusMap = {
        UNPAID: "未付款",
        PAID: "已付款",
        SERVE: "服务中",
        RECEIVING: "已接单",
        COMPLETED: "订单已完成",
        CANCEL: "已取消",
        REFUNDED: "已退款",
        OVER_TIME_PAY: "订单超时未支付",
        DELIVERED: "已发货",
        WAIT_DELIVER: "待发货",
        RECEIVED: "已收货",
      };
      return statusMap[state] || state || "未知状态";
    },

    // 获取订单类型文本
    getOrderType: function (type) {
      return this.orderTypeMap[type] || type || "未知类型";
    },

    // 获取陪诊类型文本
    getAccompanyType: function (type) {
      const typeMap = {
        COURT: '院内订单',
        WHOLE_COURSE: '全程订单',
        TEMPERATURE_TAKING: '体检订单',
      };
      return typeMap[type] || '异地订单' || '未知类型';
    },

    // 将图片字符串转换为数组
    getImageList: function (imgStr) {
      if (!imgStr) return [];
      return imgStr.split(',').filter(item => item.trim());
    },

    // 预览图片
    previewImage: function (img) {
      // 可以使用 vant 的 ImagePreview 组件，这里简单处理
      window.open(img, '_blank');
    },

    // 计算服务时长
    calculateDuration: function (startTime, endTime) {
      if (!startTime || !endTime) return '';
      try {
        const start = new Date(startTime);
        const end = new Date(endTime);
        const diff = end - start;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        return hours + '小时';
      } catch (e) {
        return '';
      }
    },

    // 拨打电话
    makeCall: function (phone) {
      if (phone) {
        window.location.href = 'tel:' + phone;
      }
    },

    // 加载订单详情
    loadDetail: function (id) {
      this.isComplete = false;
      // 如果路由参数中有下单人信息，先设置（作为备用）
      if (this.$route.query.sendUserName) {
        this.orderDetail.sendUserName = this.$route.query.sendUserName;
      }
      if (this.$route.query.sendPhone) {
        this.orderDetail.sendPhone = this.$route.query.sendPhone;
      }
      orderDetail(id)
        .then((res) => {
          this.orderDetail = res || {};
          // 如果 API 返回的数据中没有下单人信息，使用路由参数中的备用数据
          if (!this.orderDetail.sendUserName && this.$route.query.sendUserName) {
            this.orderDetail.sendUserName = this.$route.query.sendUserName;
          }
          if (!this.orderDetail.sendPhone && this.$route.query.sendPhone) {
            this.orderDetail.sendPhone = this.$route.query.sendPhone;
          }
          this.isComplete = true;
        })
        .catch(() => {
          this.isComplete = true;
        });
    },
  },
  mounted: function () {
    const id = this.$route.query.id;
    if (id) {
      this.loadDetail(id);
    } else {
      this.isComplete = true;
      this.$toast("订单ID不存在");
    }
  },
};
</script>

<style scoped>
.loading-list {
  padding: 0.4rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-bar {
  background: #3f58fd;
  color: #fff;
  padding: 0.3rem 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.2rem;
}
.status-left {
  display: flex;
  align-items: center;
}
.status-icon {
  font-size: 0.36rem;
  margin-right: 0.1rem;
}
.status-text {
  font-size: 0.32rem;
  font-weight: 600;
}
.status-right {
  font-size: 0.28rem;
}

.phone-link {
  color: #3f58fd;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.1rem;
}
.phone-icon {
  font-size: 0.32rem;
}
.wrap-box {
  padding: 0 0.2rem;
  margin: 0.2rem 0.2rem 0;
  background: #fff;
  border-radius: 0.2rem;
}
.wrap-box > .hd {
  height: 0.88rem;
  line-height: 0.88rem;
  color: #111;
  font-size: 0.28rem;
  font-weight: 600;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.wrap-box > .hd::before {
  position: relative;
  content: "";
  margin: 0 0.1rem 0 0;
  width: 0.08rem;
  height: 0.32rem;
  background: #3f58fd;
}

.base-wrap {
  padding: 0 0 0.2rem;
  font-size: 0.28rem;
}
.base-wrap > .row {
  position: relative;
  height: 0.8rem;
  line-height: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.base-wrap > .row::after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: rgba(0, 0, 0, 0.04);
}
.base-wrap > .row > .lab {
  color: #999;
  position: relative;
}
.base-wrap > .row > .lab::after {
  position: relative;
  content: "：";
}
.base-wrap > .row > .inf {
  color: #555;
}
.base-wrap > .row > .num {
  color: #c00;
  font-weight: 600;
}

.introduction {
  padding: 0 0 0.2rem;
  color: #565656;
  font-size: 0.28rem;
  line-height: 0.48rem;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;
}
.image-item {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.1rem;
  overflow: hidden;
  border: 1px solid #e1e1e1;
  cursor: pointer;
}
.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>

